module.exports = __webpack_public_path__ + "files/d1f908de35741f1590e16973ff621ad6.png";